export default __webpack_public_path__ + "static/media/titleicon4.59ceabff.svg";